import { render, staticRenderFns } from "./UserBadgesLegend.vue?vue&type=template&id=324a86de&scoped=true"
import script from "./UserBadgesLegend.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserBadgesLegend.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./UserBadgesLegend.vue?vue&type=style&index=0&id=324a86de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324a86de",
  null
  
)

export default component.exports